import { create } from "zustand";
import { safeHttpUrl } from "../lib/safeUrl";

// 외부 이동 고지 단일화(FR-COM-04). 스마트스토어·유튜브·Jitsi 등 외부 링크 클릭 시
// "외부 사이트로 이동합니다" 고지 후 새 창. native confirm 대신 일관된 모달.

/** URL 의 표시용 호스트(어디로 가는지 안내). 파싱 실패 시 원문. */
export function linkHost(url: string): string {
  try {
    return new URL(url).host;
  } catch {
    return url;
  }
}

interface ExternalLinkState {
  pending: string | null;
  /** 외부 이동 요청 → 고지 모달 표시. */
  request: (url: string) => void;
  /** 확인 → 새 창으로 열기(noopener). */
  confirm: () => void;
  cancel: () => void;
}

export const useExternalLink = create<ExternalLinkState>((set, get) => ({
  pending: null,
  request: (url) => set({ pending: url }),
  confirm: () => {
    // 활성 스킴(javascript: 등) 차단 후 새 창(불변식 7)
    const url = safeHttpUrl(get().pending);
    if (url) window.open(url, "_blank", "noopener,noreferrer");
    set({ pending: null });
  },
  cancel: () => set({ pending: null }),
}));
